import {
  selectAppliedOffers,
  selectCmsOffers,
  selectCmsSurpriseOffers,
  selectCombinedOffers,
  selectDiscountAppliedCmsOffer,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectIncentivesIds,
  selectIsDiscountNotApplied,
  selectOfferEligibleItem,
  selectOfferFeedbackMap,
  selectOfferRedemptionAvailableAfter,
  selectOffers,
  selectOffersEligibleItems,
  selectOffersLoading,
  selectPersonalizedOffers,
  selectSelectedOffer,
  selectSelectedOfferSelections,
  selectShouldRefetchOffers,
  selectSurpriseAvailable,
  selectUpsizeAvailable,
  selectUserOffers,
} from './offers/offers.selectors';
import {
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedPoints,
  selectAppliedRewardsFeedbackMap,
  selectAvailableLoyaltyRewardsMap,
  selectIsEvaluatingAppliedRewards,
  selectIsPricingRewardApplication,
  selectMaxDailyRewardRedemptionLimit,
  selectShouldRefetchRewards,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
} from './rewards/rewards.selectors';
import {
  createDailyRewardTransactionCountSelector,
  createLoyaltyUserExpireDateFormattedTextSelector,
  select12DigitSwipeCard,
  selectLoyaltyLoading,
  selectLoyaltyUser,
  selectLoyaltyUserId,
  selectUser,
} from './user/user.selectors';

export const loyaltySelectors = {
  // Offer actions
  selectAppliedOffers,
  selectCmsOffers,
  selectCmsSurpriseOffers,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectIncentivesIds,
  selectOfferFeedbackMap,
  selectOffersEligibleItems,
  selectOfferEligibleItem,
  selectOffers,
  selectOffersLoading,
  selectOfferRedemptionAvailableAfter,
  selectPersonalizedOffers,
  selectSelectedOffer,
  selectSelectedOfferSelections,
  selectSurpriseAvailable,
  selectUpsizeAvailable,
  selectUserOffers,
  selectDiscountAppliedCmsOffer,
  selectIsDiscountNotApplied,
  selectShouldRefetchOffers,
  selectCombinedOffers,
  // Rewards actions
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedPoints,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectShouldRefetchRewards,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
  selectAppliedRewardsFeedbackMap,
  selectIsEvaluatingAppliedRewards,
  selectMaxDailyRewardRedemptionLimit,
  // User actions
  select12DigitSwipeCard,
  selectLoyaltyLoading,
  selectUser,
  selectLoyaltyUser,
  selectLoyaltyUserId,
  createDailyRewardTransactionCountSelector,
  createLoyaltyUserExpireDateFormattedTextSelector,
};
